import { useState } from "react";
import { SearchBox } from "../../../../components/Search";

// Exchange filter options (first group)
const ExchangeFilters = ["IEX", "HPX", "PXIL"];

// Market filter options (second group)
const MarketFilters = ["DAM", "RTM", "GDAM"];


interface SimulationHeaderProps {
  title?: string;
  onSummaryClick?: () => void;
  selectedExchanges?: string[];
  setSelectedExchanges?: (exchanges: string[]) => void;
  selectedMarkets?: string[];
  setSelectedMarkets?: (markets: string[]) => void;
  refreshKey?: any;
  setRefreshKey?: any;
  activeTab?: string;
  setActiveTab?: (tab: string) => void;
  availableDates?: { value: string; label: string }[];
  selectedDate?: { value: string; label: string } | null;
  setSelectedDate?: (date: { value: string; label: string }) => void;
  selectedFilterDate?: any[];
  setSelectedFilterDate?: (dates: any[]) => void;
}

export default function SimulationModHeader({
  title,
  onSummaryClick,
  selectedExchanges: externalExchanges,
  setSelectedExchanges: externalSetExchanges,
  selectedMarkets: externalMarkets,
  setSelectedMarkets: externalSetMarkets,
  refreshKey,
  setRefreshKey,
  activeTab,
  setActiveTab,
  availableDates,
  selectedDate,
  setSelectedDate,
  selectedFilterDate,
  setSelectedFilterDate,
}: SimulationHeaderProps) {
  // Internal state for exchanges (default: IEX selected)
  const [internalExchanges, setInternalExchanges] = useState<string[]>(["IEX"]);
  // Internal state for markets (default: DAM selected)
  const [internalMarkets, setInternalMarkets] = useState<string[]>(["DAM"]);
  // Use external state if provided, otherwise use internal
  const selectedExchanges = externalExchanges ?? internalExchanges;
  const setSelectedExchanges = externalSetExchanges ?? setInternalExchanges;
  const selectedMarkets = externalMarkets ?? internalMarkets;
  const setSelectedMarkets = externalSetMarkets ?? setInternalMarkets;

  // Toggle exchange selection
  const toggleExchange = (exchange: string) => {
    if (selectedExchanges.includes(exchange)) {
      if (selectedExchanges.length > 1) {
        setSelectedExchanges(selectedExchanges.filter((e) => e !== exchange));
      }
    } else {
      setSelectedExchanges([...selectedExchanges, exchange]);
    }
  };

  // Toggle market selection
  const toggleMarket = (market: string) => {
    if (selectedMarkets.includes(market)) {
      if (selectedMarkets.length > 1) {
        setSelectedMarkets(selectedMarkets.filter((m) => m !== market));
      }
    } else {
      setSelectedMarkets([...selectedMarkets, market]);
    }
  };

  return (
    <div className="bg-white px-4 py-1 flex flex-wrap gap-2 justify-between items-center rounded-xl border-[0.5px] border-gray-200 shadow-sm">
      {/* Left side - Filter Groups */}
      <div className="flex items-center gap-4">
        {/* Exchange Filters Group */}
        <div className="flex items-center border border-gray-300 rounded-full bg-cyan-50">
          {ExchangeFilters.map((exchange, index) => {
            const isSelected = selectedExchanges.includes(exchange);
            const isFirst = index === 0;
            const isLast = index === ExchangeFilters.length - 1;

            return (
              <button
                key={exchange}
                onClick={() => toggleExchange(exchange)}
                className={`px-4 py-1.5 text-xs font-medium transition-colors shadow-[inset_0px_2px_4px_rgba(149,157,165,0.3)] ${
                  isSelected
                    ? "bg-[#EFFCFF] text-[#34656D]"
                    : "bg-[#FAFAFA] text-[#6F6D7C]"
                } ${isFirst ? "rounded-l-full" : ""} ${isLast ? "rounded-r-full" : ""} ${
                  !isLast && isSelected ? "border-r border-gray-300" : ""
                }`}
              >
                {exchange}
              </button>
            );
          })}
        </div>

        {/* Market Filters Group */}
        <div className="flex items-center border border-gray-300 rounded-full bg-orange-50">
          {MarketFilters.map((market, index) => {
            const isSelected = selectedMarkets.includes(market);
            const isFirst = index === 0;
            const isLast = index === MarketFilters.length - 1;

            return (
              <button
                key={market}
                onClick={() => toggleMarket(market)}
                className={`px-4 py-1.5 text-xs font-medium transition-colors shadow-[inset_0px_2px_4px_rgba(149,157,165,0.3)] ${
                  isSelected
                    ? "bg-[#FFFAF6] text-[#F1935C]"
                    : "bg-[#FAFAFA] text-[#6F6D7C]"
                } ${isFirst ? "rounded-l-full" : ""} ${isLast ? "rounded-r-full" : ""} ${
                  !isLast && isSelected ? "border-r border-gray-300" : ""
                }`}
              >
                {market}
              </button>
            );
          })}
        </div>
      </div>

      {/* Right side - Summary Button + Date Selector */}
      <div className="flex items-center gap-3">
        <button
          onClick={onSummaryClick}
          className="px-4 py-1.5 text-xs font-medium text-[#34656D] border border-[#AEC1C5] rounded-full bg-[#EFFCFF]"
        >
          Summary
        </button>

        {availableDates &&
          availableDates.length > 0 &&
          selectedFilterDate &&
          setSelectedFilterDate && (
          
              <SearchBox
                options={availableDates}
                isMany={false}
                placeholder="Select Date"
                selectedOptions={selectedFilterDate}
                onChange={(val: any) => {
                  if (val) {
                    setSelectedFilterDate(Array.isArray(val) ? val : [val]);
                  } else {
                    setSelectedFilterDate([]);
                  }
                }}
              />
            
          )}
      </div>
    </div>
  );
}

